export default __webpack_public_path__ + "static/media/physics.ee97676b.svg";